import { Injectable, NgModule } from '@angular/core';
import { DataApiService, BaseService } from '@xpo-ltl/data-api';
import { ConfigManagerService, CONFIG_MANAGER_SERVICE_CONFIGURATION, ConfigManagerModule } from '@xpo-ltl/config-manager';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@xpo-ltl/data-api';
import * as ɵngcc2 from '@xpo-ltl/config-manager';
class AccountsReceivableApiService extends BaseService {
    /**
     * @param {?} dataApiService
     * @param {?} configManager
     */
    constructor(dataApiService, configManager) {
        super();
        this.dataApiService = dataApiService;
        this.configManager = configManager;
    }
    /**
     * Health check URL. Responds with success message if the service is running.
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    healthCheck(dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/health-check'), {}, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * List of resources.
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    options(dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/options'), {}, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * Details of user invoking the API.
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    loggedInUser(dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/appusers/logged-in-user'), {}, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This service operation will retrieve AR details by pro number.
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    listArPaymentDetailsByPro(queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/arpayments/details'), {
            queryParams: queryParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This service operation will retrieve AR summary lines by pro number.
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    listArPaymentSummaryByPro(queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/arpayments/summaries'), {
            queryParams: queryParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This service operation will retrieve AR summary lines for multiple PROs.
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    listArPaymentSummaryByMultiPros(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/arpayments/shipments/summaries'), {
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * @return {?}
     */
    getEndPoint() {
        return this.configManager.getSetting(AccountsReceivableApiService.AccountsReceivableApiEndpoint);
    }
}
AccountsReceivableApiService.ɵfac = function AccountsReceivableApiService_Factory(t) { return new (t || AccountsReceivableApiService)(ɵngcc0.ɵɵinject(ɵngcc1.DataApiService), ɵngcc0.ɵɵinject(ɵngcc2.ConfigManagerService)); };
AccountsReceivableApiService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: AccountsReceivableApiService, factory: AccountsReceivableApiService.ɵfac });
AccountsReceivableApiService.AccountsReceivableApiEndpoint = 'accountsreceivableApiEndpoint';
/** @nocollapse */
AccountsReceivableApiService.ctorParameters = () => [
    { type: DataApiService },
    { type: ConfigManagerService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AccountsReceivableApiService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.DataApiService }, { type: ɵngcc2.ConfigManagerService }]; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
const ɵ0 = { configFileUrl: './assets/config.json' };
class SdkAccountsReceivableModule {
}
SdkAccountsReceivableModule.ɵfac = function SdkAccountsReceivableModule_Factory(t) { return new (t || SdkAccountsReceivableModule)(); };
SdkAccountsReceivableModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: SdkAccountsReceivableModule });
SdkAccountsReceivableModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        AccountsReceivableApiService,
        { provide: CONFIG_MANAGER_SERVICE_CONFIGURATION, useValue: ɵ0 },
    ], imports: [[
            ConfigManagerModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SdkAccountsReceivableModule, [{
        type: NgModule,
        args: [{
                imports: [
                    ConfigManagerModule
                ],
                providers: [
                    AccountsReceivableApiService,
                    { provide: CONFIG_MANAGER_SERVICE_CONFIGURATION, useValue: ɵ0 },
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SdkAccountsReceivableModule, { imports: function () { return [ConfigManagerModule]; } }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * AccountsReceivable API
 * Version: 1.0
 * Build: 1.0-1.0.0.3
 */
class ListArPaymentDetailsByProQuery {
    constructor() {
        /**
         * Required: false
         * Array: false
         */
        this.proNbr = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.pickupDate = undefined;
    }
}
class ListArPaymentDetailsByProResp {
    constructor() {
        /**
         * Required: false
         * Array: true
         */
        this.arPaymentDetails = undefined;
    }
}
class ListArPaymentSummaryByProQuery {
    constructor() {
        /**
         * Required: false
         * Array: false
         */
        this.proNbr = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.pickupDate = undefined;
    }
}
class ListArPaymentSummaryByProResp {
    constructor() {
        /**
         * Required: false
         * Array: true
         */
        this.arPaymentSummaries = undefined;
    }
}
class ListArPaymentSummaryByMultiProsRqst {
    constructor() {
        /**
         * Contains identifying information for shipments.
         * Required: true
         * Array: true
         */
        this.shipments = undefined;
    }
}
class ListArPaymentSummaryByMultiProsResp {
    constructor() {
        /**
         * Required: false
         * Array: true
         */
        this.arPaymentSummaries = undefined;
    }
}
class ArPaymentDetail {
    constructor() {
        /**
         * Required: false
         * Array: false
         */
        this.proNbr = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.currencyCd = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.custNbr = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.receiptNbr = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.chargeCd = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.paymentDate = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.totalChargeAmt = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.totalPaymentAmt = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.totalAdjustmentAmt = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.balanceDueAmt = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.creditedAmt = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.inDisputeAmt = undefined;
    }
}
class ArPaymentSummary {
    constructor() {
        /**
         * Required: false
         * Array: false
         */
        this.proNbr = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.totalChargeAmt = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.totalPaymentAmt = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.totalAdjustmentAmt = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.balanceDueAmt = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.creditedAmt = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.inDisputeAmt = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.chargeCd = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.proStatusCd = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.paymentStatusTxt = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.shipmentInstId = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.pickupDate = undefined;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

export { SdkAccountsReceivableModule, AccountsReceivableApiService, ListArPaymentDetailsByProQuery, ListArPaymentDetailsByProResp, ListArPaymentSummaryByProQuery, ListArPaymentSummaryByProResp, ListArPaymentSummaryByMultiProsRqst, ListArPaymentSummaryByMultiProsResp, ArPaymentDetail, ArPaymentSummary };

